import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'

import 'vuesax/dist/vuesax.css' // Vuesax
import 'material-icons/iconfont/material-icons.css' //Material Icons

import { hasPermissionBackOffice } from './utils';

import VsSelectOverwriteEvents from './overwrite/vs-select/overwrite-event.js';

Vue.use(Vuesax);
Vue.use(VsSelectOverwriteEvents);

// axios
localStorage.setItem('baseUrl', process.env.VUE_APP_API_BASE_URL)
import axios from "./axios.js"
Vue.prototype.$http = axios

// API Calls
import "./http/requests"

// register globally
import GlobalEvents from 'vue-global-events'
Vue.component('GlobalEvents', GlobalEvents)
import VueCountdown from '@chenfengyuan/vue-countdown';
Vue.component(VueCountdown.name, VueCountdown);
import VueEvents from 'vue-events'
Vue.use(VueEvents)

// Theme Configurations
import '../themeConfig.js'

// Auth0 Plugin
import AuthPlugin from "./plugins/auth"
Vue.use(AuthPlugin)

import './plugins/flatpickrCloseOnScroll'

// Masks
import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

// Money Mask
import money from 'v-money'
Vue.use(money)

// ACL
import acl from './acl/acl'

// Globally Registered Components
import './globalComponents.js'

// Styles: SCSS
import './assets/scss/main.scss'

// Tailwind
import '@/assets/css/main.css'

// Vue Router
import router from './router'

// Vue Analytics
import VueAnalytics from 'vue-analytics';
Vue.use(VueAnalytics, {
    id: 'G-220RRKR6L5',
    router
});
// Vuex Store
import store from './store/store'

// i18n
import i18n from './i18n/i18n'

// Vuexy Admin Filters
import './filters/filters'

// Import websockets
import '@/websockets/client.js'

// Clipboard
Vue.use(VueClipboard)
import VueClipboard from 'vue-clipboard2'

// Tour
import VueTour from 'vue-tour'

require('vue-tour/dist/vue-tour.css')

Vue.use(VueTour)

// VeeValidate
import VeeValidate from 'vee-validate'
import messages from 'vee-validate/dist/locale/pt_BR'

// Merge the locales.
Vue.use(VeeValidate)
VeeValidate.Validator.localize('pt_BR', messages)

import _ from 'lodash'
Object.defineProperty(Vue.prototype, '$_', { value: _ })

// Google Maps
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
    load: {
        // Add your API key here
        key: 'YOUR_API_KEY',
        libraries: 'places' // This is required if you use the Auto complete plug-in
    }
})

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'

Vue.use(VueHammer)

// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

// Feather font icon
require('./assets/css/iconfont.css')

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css'

Vue.config.productionTip = false

const vue = new Vue({
    router,
    store,
    i18n,
    acl,
    render: h => h(App)
}).$mount('#app')

router.afterEach((to) => {
    localStorage.setItem('baseUrl', process.env.VUE_APP_API_BASE_URL)

    if (vue.$router.match(to).meta.rule === 'check') {
        const currentRoute = vue.$router.match(to);
        const currentRouteName = currentRoute.meta.permissionRoute || vue.$route.name;
        let hasRouteName = hasPermissionBackOffice(currentRouteName);

        if (!hasRouteName) {
            return vue.$router.push('/pages/not-authorized');
        }
    }
})

export default vue